export default __webpack_public_path__ + "static/dont-links-3_1-4f5fa0b8d760d4e82a5229c500cf067c.png";